import React from "react";
import { ReactNode } from "react";

export interface Heading2Props {
  heading?: ReactNode;
  subHeading?: ReactNode;
  className?: string;
  totalPages?: number;
}

const Heading2: React.FC<Heading2Props> = ({
  className = "",
  heading = "",
  subHeading,
  totalPages
}) => {
  return (
    <div className={`mb-6 lg:mb-6 ${className}`}>
      <h2 className="text-4xl font-semibold">{heading}</h2>
      {subHeading ? (
        subHeading
      ) : (
        <span className="block text-neutral-500 dark:text-neutral-400 mt-3">
          {totalPages} Tiny Houses Available
          <span className="mx-2">·</span>
          {/*Aug 12 - 18*/}
          <span className="mx-2">·</span>{/*2 Guests*/}
        </span>
      )}
    </div>
  );
};

export default Heading2;
